import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";

import { AbstractBuyerComponent } from "./buyer.component";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";

@Component({
    template: "",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class AbstractAdvisorComponent extends AbstractBuyerComponent {
    constructor(
        router: Router,
        route: ActivatedRoute,
        dialog: MatDialog,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService
    ) {
        super(router, route, dialog, authService, analyticsService, generalService);
        this.initPromises.push(
            this.reloadUser()
                .then(u => {
                    if (!u.isAdvisor) {
                        this.authService.logout();
                        this.router.navigate(["/user/login"]);
                    }
                })
        );
    }

    ngOnInit(): void {
        super.ngOnInit();
    }
}